import { Typography, Box } from '@mui/material';
import styled from 'styled-components';

const BoxContainer = styled(Box)`
    display:flex;
    flex-direction:column;
    gap=20px;
`;

const OngoingLogs = () => {
    return (
        <BoxContainer>
            <Typography variant='h6' component={'p'} >Ongoing</Typography>
        </BoxContainer>
    )
}

export default OngoingLogs
